import {forEach} from "lodash";
import {AppInjector} from "@wms/variables";
import {FileService} from "@wms/services";

export const CONSTANTS: any = {
  MAIN_PAGE       : 'Main',
  PAGE_DIRECTORY  : '../../../pages/'
};

export interface Tab {
  name      : string,
  title     : string,
  isActive  : boolean
}

export interface Config {
  displayName: string,
  group: string,
  iconUrl: string,
  resources: {
    styles: string[],
    scripts: string[]
  },
  properties: object,
  events: object,
  methods: object,
  [key: string]: any;
}

export interface Event {
  name ?: string;
  displayName ?: string;
  description ?: string;
  widget ?: string;
}

export interface NewProps {
  script?: string;
  style?: string;
  [key: string]: any;
}

export interface KeyValue {
  key: string;
  value: string;
}

export interface AppEnv extends KeyValue {
  name: string;
}

export interface Parameter {
  name        ?: string;
  type        ?: string;
  description ?: string;
}

export interface Method {
  name          ?: string;
  tempName      ?: string;
  type          ?: string;
  parameters    : Parameter[];
  returnType    : string;
  [key: string] : any;
}

export interface NormalizedMethod {
  name      : string;
  params    : string;
  comments  : string;
}

export function removeUndefinedKeys(data: any) {
  return data.filter(function (item: any) {
    if (!item) {
      return;
    }
    return item;
  });
}

export function _removeProperty(array: any[], item: any) {
  var index = array.indexOf(item);
  array.splice(index, 1);
}

export function propertyDisplayNameExists(propType: string, propName: string, data: any[]) {
  let nameExists = false;
  // @ts-ignore
  forEach(data, (item: any) => {
    if (item.displayName === propName || item.tempName === propName) {
      nameExists = true;
      return false;
    }
  });
  return nameExists;
}

export function assignNewPropIndexByType(propType: string, propIndex: number, key: string, data: any[]) {
  if (propertyDisplayNameExists(propType, key + propIndex, data)) {
    propIndex++;
    assignNewPropIndexByType(propType, propIndex, key, data);
  }
  return propIndex;
}

// @ts-ignore
export function readFileByPath(path: string, successCallback: Function, errorCallback: Function) {
  if (!path)
    return false;

  let fileService = AppInjector.get(FileService);
  fileService.read(path).then((response: any) => successCallback(response), (error: any) => errorCallback());
}

// @ts-ignore
export function writeFileByPath(path: string, content: any, successCallback: Function, errorCallback: Function) {
  if (!path)
    return false;

  let fileService = AppInjector.get(FileService);
  fileService.write(path, content).then(() => successCallback(), () => errorCallback());
}
export function isNonEmptyString(value: string) {
  return value && value.trim().length;
}
